import './index.less';


// WEBPACK FOOTER //
// ./src/view/newDetail/index.js